module.exports = __webpack_public_path__ + "img/GL.4e893be2.png";